import { QueryFunctionContext } from '@tanstack/react-query'
import anklePatrolAxios from '../../../services/config/axiosClient'
import { subAdminsAPIRoutes } from './apiRoutes'
import { SubAdminCreate, SubAdminEnabled } from './types/APIRequestType'

export const subAdmins = ({ queryKey }: QueryFunctionContext) =>
  anklePatrolAxios.get(
    `${subAdminsAPIRoutes.subAdmins}?limit=${queryKey?.[1]}&page=${queryKey?.[2]}&search=${queryKey?.[3]}`,
  )

export const createSubAdmins = (payload: SubAdminCreate) =>
  anklePatrolAxios.post(subAdminsAPIRoutes.createSubAdmins, payload)

export const subAdminEnabled = (payload: SubAdminEnabled) =>
  anklePatrolAxios.put(subAdminsAPIRoutes.subAdminEnabled, payload)
